import { z } from 'zod';

import { DocumentStatus } from '../../enums';
import type { EndpointContractGroup } from '../schemaUtils';

export const easyAccessSchema = z.object({
  url: z.string(),
});

export type EasyAccess = z.infer<typeof easyAccessSchema>;

export type UrlStatusUpdate = {
  id: string;
  url: string;
  status: DocumentStatus;
};

/**
 * Schema definition for all agents endpoints
 */
export const agentsApiSchemas = {
  summary: {
    path: '/agents/:agentId/summary',
    method: 'GET',
    schema: {
      params: z.object({
        agentId: z.string().uuid(),
      }),
      response: {
        200: z.object({
          webUrl: z.string(),
          documents: z.array(
            z.object({
              id: z.string().uuid(),
              uri: z.string(),
              publicUrl: z.string(),
              status: z.nativeEnum(DocumentStatus),
            }),
          ),
        }),
      },
    },
  },
} satisfies EndpointContractGroup;

/**
 * Agent endpoints types
 */
export type AgentsSummaryResponse = z.infer<
  (typeof agentsApiSchemas.summary.schema.response)[200]
>;
